import styled from 'styled-components';

export const StackedIconContainer = styled.div`
  display: grid;
  place-items: center;
  position: relative;

  & > * {
    grid-area: 1 / 1 / 2 / 2;
  }
`;
